import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the ProgramDispensingHistoryUploadPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-program-dispensing-history-upload',
  templateUrl: 'program-dispensing-history-upload.html',
})
export class ProgramDispensingHistoryUploadPage {

  uploadedHistory: any[] = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProgramDispensingHistoryUploadPage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/program-dispensing-history-upload/program-dispensing-history-upload.ts